import { render, staticRenderFns } from "./IconTruckSolid.vue?vue&type=template&id=11c6dd25"
import script from "./IconTruckSolid.vue?vue&type=script&lang=js"
export * from "./IconTruckSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports